import {useEffect, useState} from 'react';

export default function useWindowSize(): {width; height} {
    const [size, setSize] = useState([0, 0]);
    const updateSize = () => setSize([window.innerWidth, window.innerHeight]);
    useEffect(() => {
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    const [width, height] = size;
    return {width, height};
}
